import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Clock, ArrowRight } from 'lucide-react';
import { excursions } from '../mock';
import { useI18n } from '../i18n';
import { Button } from '../components/ui/button';
import HoverVideoCard from '../components/HoverVideoCard';

const Excursions = () => {
  const { t, lang } = useI18n();
  return (
    <div className="pt-[72px] bg-white">
      <section className="relative bg-black text-white py-24">
        <div className="absolute inset-0 bg-cover bg-center opacity-50" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1591884099753-50f5dac1de56?w=1600&q=80')" }} />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/30" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.4em] uppercase text-white/60">
            {lang === 'fr' ? 'Excursions \u00e0 la journ\u00e9e' : 'Day trips'}
          </p>
          <h1 className="font-serif text-5xl md:text-6xl mt-4 max-w-3xl leading-[1.05]">
            {lang === 'fr' ? 'Transferts \u00e0 travers la France' : 'Transfers across France'}
          </h1>
          <p className="text-white/70 mt-5 max-w-2xl text-lg">
            {lang === 'fr'
              ? 'De Giverny aux ch\u00e2teaux de la Loire, de la Champagne aux plages du D\u00e9barquement \u2014 nous vous emmenons aux plus beaux sites de France, avec chauffeur priv\u00e9 anglophone.'
              : 'From Giverny to the Loire ch\u00e2teaux, from Champagne to the D-Day beaches \u2014 we drive you to France\u2019s finest landmarks with an English-speaking private chauffeur.'}
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {excursions.map(e => (
              <article key={e.id} className="group bg-white border border-black/10 hover:shadow-xl transition-shadow overflow-hidden">
                <div className="aspect-[16/10] overflow-hidden">
                  <HoverVideoCard image={e.image} youtubeId={e.youtubeId} alt={e.nameFr} />
                </div>
                <div className="p-6">
                  <p className="text-[11px] tracking-[0.3em] uppercase text-black/50">{e.region}</p>
                  <h3 className="font-serif text-2xl mt-2">{lang === 'fr' ? e.nameFr : e.nameEn}</h3>
                  <p className="text-black/60 mt-3 text-sm leading-relaxed line-clamp-3">{lang === 'fr' ? e.descFr : e.descEn}</p>
                  <div className="flex items-center gap-4 mt-5 text-xs text-black/50">
                    <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {e.region.split(',')[0]}</span>
                    <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> {e.distance}</span>
                  </div>
                  <Link to="/contact" className="mt-5 inline-flex items-center gap-2 text-sm font-medium border-b border-black pb-1">
                    {lang === 'fr' ? 'Demander un devis' : 'Request a quote'} <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#f6f4f1] py-20">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 text-center">
          <h2 className="font-serif text-4xl md:text-5xl">
            {lang === 'fr' ? 'Itin\u00e9raires sur mesure' : 'Bespoke itineraries'}
          </h2>
          <p className="text-black/60 mt-5 leading-relaxed text-lg">
            {lang === 'fr'
              ? 'Nous concevons votre voyage selon vos envies : journ\u00e9e d\u00e9couverte, week-end gastronomique, road-trip culturel \u2014 avec chauffeur priv\u00e9, accueil bilingue et v\u00e9hicule \u00e0 la hauteur.'
              : 'We design your trip to match your wishes: discovery day, gastronomic weekend, cultural road-trip \u2014 with private chauffeur, bilingual welcome and a fitting vehicle.'}
          </p>
          <Link to="/contact" className="inline-block mt-8">
            <Button className="bg-black hover:bg-black/85 text-white rounded-none h-12 px-8 text-sm tracking-[0.2em] uppercase">
              {t('cta.btn')} <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Excursions;
